$.fn.loading = function(){
  	var cssPosition = $(this).css('position');
  return (cssPosition === 'fixed' || cssPosition === 'absolute') ? $(this).append(spinner) : $(this).css('position','relative').append(spinner);
}

$.fn.stopLoading = function(){
	return $(this).find('.spinner').remove();
}

function handlelize(str){
    str = String(str);
    return str.toLowerCase().trim().replace(/[\s_\/]+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-');
}

var lastScrollTop = 0,
    MODAL_PROMISE,
    CART_QTY_TIMEOUT,
    MOBILE = $(window).width() <= 960;

$(document).ready(function(){
	
	initHeader();
  	initFilters();
    initFancyBox();
  	toggleSickyElements();
  	initCountDown()

}).on('click', '.vt-panels-dropdown-toggle, .vt-panels-dropdown-item', function(){
    var text = $('.vt-panels-dropdown-toggle').text(),
        dataText = $('.vt-panels-dropdown-toggle').data('text');
  	$('.vt-panels-dropdown-toggle').toggleClass('active').text(dataText).data('text', text);
    $('.vt-panels-dropdown').toggle();
}).on('click', '.vt-promotion-banner-close', function(){

	$('.vt-promotion-banner').hide();
    initHeader();
    toggleSickyElements();
  
}).on('click', '[data-chat], [href="/#chat"], [href="#chat"]', function(){
	
  	$zopim(function() {
      $zopim.livechat.window.toggle();
    });
  
//   	var ShopifyChat = document.querySelector('[name="dummy-chat-button-iframe"]') || document.querySelector('#ShopifyChat');
  

//     $('body').addClass('chat-in')
  
//   	if(ShopifyChat && ShopifyChat.contentWindow && ShopifyChat.contentWindow.document){
//       	ShopifyChat.contentWindow.document.querySelector('[data-spec="toggle-button"]').click()
       
        
//     }
  
	return false
  
}).on('click', '[data-attentive], [href^="/#attentive"], [href^="#attentive"]', function(){
	
  var desktop_creative_id,
         mobile_creative_id;



     if($(this).data('attentive')){
         var attentive = $(this).data('attentive').split('-');
         if(attentive[1]){
           desktop_creative_id = attentive[1]
         }
         if(attentive[2]){
           mobile_creative_id = attentive[2]
         }
     }else{
         var attentive = $(this).attr('href').split('-');
         if(attentive[1]){
           desktop_creative_id = attentive[1]
         }
         if(attentive[2]){
           mobile_creative_id = attentive[2]
         }
     }
     if(window.innerWidth >= 760){
        //call the desktop creative
        if(desktop_creative_id){
          window.__attentive.trigger(null,null,null, desktop_creative_id)
        }
    } else {
        //call the mobile creative  
        if(mobile_creative_id){
          window.__attentive.trigger(null,null,null, mobile_creative_id)
        }else if(desktop_creative_id){
          window.__attentive.trigger(null,null,null, desktop_creative_id)
        }
    }
  
	return false

}).on('click', '[href="/cart"]', function(){
	
  	openCart()
    closeModal()
  
	return false;
  
}).on('click', '[data-atc]', function(e){
          
  $this = $(this);

  if(!$this.attr('href') || $this.attr('href') === '#'){
	
      var qtyInput = $(this).siblings('[data-atc-qty]'),
          confirm = $(this).data('confirm') || '',
          confirm_size = $(this).data('confirm-size') || '',
          available = qtyInput.data('available'),
          id = $(this).data('atc'),
          qty = Number(qtyInput.val() || 1),
          source = $(this).data('source'),
          backorder = $(this).data('backorder'),
          clearance = $(this).data('clearance'),
          trimKitId = $this.attr('data-trim-kit') || $this.closest('.vt-product-content').find('[data-trim-kit-checkbox]:checked').val(),
          properties = {
            _source : source ? source : undefined,
            _backorder : backorder ? backorder : undefined,
            _clearance : clearance ? clearance : undefined
          };

     if(location.search.indexOf('upsell') > -1 && !properties._source){
       properties._source = 'upsell';
     }

     if(location.search.indexOf('stl=yes') > -1 && !properties._source){
       properties._source = 'stl';
     }
    
    	
     if(confirm_size){
       
       openModal({
          name:'atc-size-confirm',
          //header : '<h3 class="px-3">Please note:</h3>',
          body : `<div class="px-3">
			  ${confirm_size}
              <hr class="my-3"/>
              <div class="pb-3 d-flex justify-content-center">
				   <input type="hidden" data-atc-qty value="${qty}" />
                   <button class="btn btn-sm px-md-5 btn-outline-secondary" modal-close>Cancel</button>
                   <button class="btn btn-sm px-md-5 btn-secondary ml-3" data-atc="${id}" data-confirm="${confirm}" data-backorder="${backorder}" data-source="${source}" data-trim-kit="${trimKitId || ''}">Yes</button>
              </div>
              </div>`
       })
     
     }else if(confirm){
              
       openModal({
          name:'atc-confirm',
          //header : '<h3 class="px-3">Please note:</h3>',
          body : `<div class="px-3">
			  ${confirm}
              <hr class="my-3"/>
              <div class="pb-3 d-flex justify-content-center">
					<input type="hidden" data-atc-qty value="${qty}" />
                    <button class="btn btn-sm px-md-5 btn-outline-secondary" modal-close>Cancel</button>
                   <button class="btn btn-sm px-md-5 btn-secondary ml-3" data-atc="${id}" data-backorder="${backorder}" data-trim-kit="${trimKitId || ''}">Add To Cart</button>
              </div>
              </div>`
       })
     
     }else if(qty > available){
    	openModal({
          name:'atc-confirm',
          //header : '<h3 class="px-3">Please note:</h3>',
          body : `<div class="px-3">
			  Please note that only <span class="font-weight-bold">${available}</span> of this item is in stock. The remaining qty of <span  class="font-weight-bold">${qty - available}</span> will ship at a later date. <br> Please <a href="/pages/contact-us" target="_blank">contact us</a> for further information.
              <hr class="my-3"/>
              <div class="pb-3 d-flex justify-content-center">
					<input type="hidden" data-atc-qty value="${qty}" />
                  <button class="btn btn-sm px-md-5 btn-outline-secondary" modal-close>Cancel</button>
                   <button class="btn btn-sm px-md-5 btn-secondary ml-3" data-atc="${id}" data-trim-kit="${trimKitId || ''}">Add To Cart</button>
              </div>
              </div>`
       })
       
     } else {
      $this.loading()
      
      if($('.vt-swatches').length){
        
        $.get('/cart.json').then(function(cart){

          var totalSwatchesInCart = cart.items.reduce(function(total, item){
          
            return total + (item.product_type === 'swatch' ? item.quantity : 0);
          
          },0);
          
          if(true || totalSwatchesInCart < 7){
          		jQuery.post('/cart/add.js', {
                  quantity: qtyInput.val() || 1,
                  id: id,
                  properties : properties
                }, function(cart){

                  $this.stopLoading();   
                  closeModal()

                  updateHeaderCart();
                  
                  // $this.text('Added').addClass('added').attr('data-atc',null).data('remove-link', id)
                  $this.hide().siblings().show()

                }, "json");
          }else{
          		
            	$this.stopLoading(); 
            	openModal({
                    name:'swatch-limit',
                    //header : '<h3 class="px-3">Please note:</h3>',
                    body : `<div class="px-3 text-center">
                        <h4 class="">
							Oops, you have reached your limit. Only <span class="font-weight-bold">7</span> swatch samples are allowed. 
						</h4>
                        <hr class="my-3"/>
                        <div class="pb-3 d-flex justify-content-center">
                            <a href="/cart" class="btn btn-sm px-md-5 btn-outline-secondary mx-2">Edit your cart</a>
                             <a href="/pages/sample-swatches" class="btn btn-sm px-md-5 btn-secondary mx-2 text-white">Buy all samples</a>
                        </div>
                        </div>`
                 })
          
          }
        })
        
        
      }else{
      
          var cartAddRequest;

          if(trimKitId){
            cartAddRequest = jQuery.ajax({
              url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js',
              method: 'POST',
              contentType: 'application/json',
              dataType: 'json',
              data: JSON.stringify({
                items: [{
                  quantity: qty,
                  id: id,
                  properties: properties
                }, {
                  quantity: qty,
                  id: trimKitId
                }]
              })
            });
          }else{
            cartAddRequest = jQuery.post('/cart/add.js', {
              quantity: qtyInput.val() || 1,
              id: id,
              properties : properties
            }, null, 'json');
          }

          cartAddRequest.done(function(cart){
            $this.stopLoading();   
            closeModal()

            openCart()
          });
      } 
     }

      return false

  }else{
   	 window.location.href = $this.attr('href');
  }
    
}).on('click', '.vt-cart-overlay, .vt-cart-close', function(){
	
  	closeCart()
  
	return false;
  
}).on('click', '[data-discount-apply]', function(){
	
  	var discount = $('[data-discount]:visible').val().trim();
      
    if(discount){
      
      	$('.cart-totals').loading()
    
      	$.get('/discount/' + discount).then(function(){
        	
          	updateTotals();
          
          	$('.cart-totals').stopLoading()
          
        });
      
    }
  
}).on('keydown', '[data-discount]', function(event){
  	
  	var discount = $(this).val().trim(),
        keycode = (event.keyCode ? event.keyCode : event.which);
      
    if(keycode === 13 && discount){
      
      	event.preventDefault();
      
      	$('.cart-totals').loading()
    
      	$.get('/discount/' + discount).then(function(){
        	
          	updateTotals();
          
          	$('.cart-totals').stopLoading()
          
        });
      
    }
  
}).on('click', '[data-collection-type]', function(){

  
  	var isProductPage = window.location.pathname.indexOf('product') > -1,
        isPreviewFilter = $(this).closest('.vt-collection-filters-preview').length,
    	  type = $(this).data('collection-type'),
        href = $(this).attr('href'),
        option1name = $('.vt-filter-link-container.selected').data('option1name'),
    	  option1 = $('.vt-filter-link-container.selected').data('option1'),
    	  option2name = $('.vt-filter-link-container.selected').data('option2name'),
        option2 = $('.vt-filter-link-container.selected').data('option2'),
        link = [];
 
  	if(type){
    	//link.push(type)
    }
    // if(href){
    //     link.push(href)
    // }
  	if(option1){
    	link.push(handle(option1name + '_' + option1))
    }
  	if(option2){
    	link.push(handle(option2name + '_' + option2))
    }
  
  	link = link.join('+');
  
  	$(this).addClass('selected').siblings().removeClass('selected');

    if(isPreviewFilter){
            
      var $preview = $('.vt-collection-filters-preview');
      
      // $preview.loading().load(COLLECTION_URL + '/' + link + ' .vt-collection-container-reload', function(){
      //     $preview.addClass('loaded').find('.vt-collection-filters').remove();
      // })

      $preview.loading().load(href + '/' + link + ' .vt-collection-container-reload', function(){
          $preview.addClass('loaded').find('.vt-collection-filters').remove();
      })
    
    }else{

      	filterPage({
            link : href + '/' + link,
            fullReload : isProductPage
        }); 

        if(!isProductPage){
          let collection_title = $(this).data('collection-title')
          if(collection_title){
            $('.vt-collection-title').text(collection_title)
          }
        }
      	
      	
        // filterPage({
        //     link : COLLECTION_URL + '/' + link,
        //     fullReload : isProductPage
        // });  
      
    }
      
  	return false

}).on('change', '.vt-filter-link-container input', function(e){
	
  	_initFilters(true, e);
  
}).on('click', '.vt-filter-link-container input', function(e){
  
  	$(this).attr('checked', 'checked')
	
  	if(!$(this).closest('[data-filter-group]').next('[data-filter-group]').length){
  		
      	
      	if($(this).attr('checked') === 'checked'){
          closeMobileFilters()
        }
      
    }
  
}).on('click', '.vt-filter-more', function(){
	
  	$(this).addClass('d-none').closest('.vt-filters-group').find('.available').removeClass('d-none')
  
}).on('click', '[data-product-link]', function(){
	
//   	filterPage({
//   		link : $(this).attr('href'),
//       	fullReload : true
// 	})
    
//     return false;
  
}).on('click', '.vt-faq-question', function(){
    	
    $(this).find('.icon').toggle();
    $(this).next().slideToggle()

}).on('click', '.vt-faq-more', function(){
    	
  	$('.vt-faq-item.collapse').slideDown();
  	$('.vt-faq-more').fadeOut();

}).on('click', '.vt-filter-header', function(){
  	//$(this).toggleClass('closed').next().slideToggle();
  	//toggleSickyElements(true)
}).on('click', '[modal-close]', function(){

  	closeModal()
  
}).on('click', '[data-qty-increase]', function(){
	
  	var $qty = $(this).closest('[data-qty-tool]').find('input'),
    	qty = Number($qty.val() || 1);
  
    $qty.val(qty + 1);
  	clearTimeout(CART_QTY_TIMEOUT);
  	CART_QTY_TIMEOUT = setTimeout(function(){
    	$qty.change();
    }, 100);
  
}).on('click', '[data-qty-decrease]', function(){

  	var $qty = $(this).closest('[data-qty-tool]').find('input'),
    	qty = Number($qty.val() || 1);
  	
  	$qty.val(qty - 1);
  	clearTimeout(CART_QTY_TIMEOUT);
  	CART_QTY_TIMEOUT = setTimeout(function(){
    	$qty.change();
    }, 100);    
  
}).on('click', '[data-trim-kit-details]', function(e){

	e.preventDefault();

  	var $block = $(this).closest('[data-trim-kit-block]'),
    	title = $(this).data('trim-kit-title'),
    	content = $block.find('[data-trim-kit-details-content]').html();

  	openModal({
      name : 'trim-kit-details',
      header : title ? '<h3>'+ title +'</h3>' : '',
      body : '<div class="px-3 pb-3">'+ (content || '') +'</div>'
    });

}).on('click', '[data-video-popup]', function(){

	
  	var video = $(this).data('video-popup');
  	if(video){
      	openModal({          
          body : '<div class="vt-video-container"><iframe class="w-100" src="'+ video +'?autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe></div>'
        })
        return false
    }
  	
	
}).on('click', '.vt-product-slide', function(e){
  
    if(!$(this).hasClass('vt-gift-card-image')){
      e.stopImmediatePropagation()
    }
	var image = $(this).data('image'),
        _3d = $(this).data('3d');
    if(image){
        //$('.vt-product-detail .vt-product-3d').removeClass('active');
    	  //$('.vt-product-detail .vt-product-image-container').attr('href', image).css('background-image', 'url("'+ theme.Images.getSizedImageUrl(image, '1000x') +'")');
    }

    if(_3d){
    	//$('.vt-product-detail .vt-product-3d').addClass('active');
    }
  	//$('.vt-product-slide').removeClass('selected');
  	//$(this).addClass('selected');
  
    if(MOBILE){
      	$.fancybox.open( $('.vt-product-slide a'), {
            thumbs : {
                autoStart : true,
                axis      : 'x'
            },
            hash : false,
            buttons : [
                'thumbs',
                'zoom',
                'close'
            ],
           onInit: function(){
          	$.fancybox.getInstance().jumpTo($('.vt-product-slide.selected').index());
          }
        });
    }
  
  	//return false;
}).on('click', '.vt-product-description-more', function(){
	$(this).hide();
  	$('.vt-product-description').addClass('open')
}).on('click', '.vt-product-detail .vt-product-image-container', function(){	
  
  $('.selected [data-fancybox="vt-fancybox"]').click()
  return false;
  
}).on('click', '.vt-filters-mobile-opener', function(){
	closeMobileFilters()
}).on('click', '[data-code]', function(){

	var code = $(this).data('code'),
        $temp = $("<input>");
  
  	$("body").append($temp);
  
  	$temp.val(code.trim()).select();
  	document.execCommand("copy");
  	$temp.remove();
  
    $(this).text('copied');

}).on('click', '.vt-product-description blockquote a', function(){
	
  	
  	$.get($(this).attr('href'), function(res){
    
    		openModal({          
              body : res
            })
      
    })
  	return false
  
}).on('click', '.vt-collection-filters:visible .vt-filter-link-container', function(){

  if($(this).is('[data-native-filter-link]')){
    return;
  }

	
  	var PRODUCT_URL = window.location.pathname,
        isProduct = PRODUCT_URL.indexOf('product') > -1,
        type = $('[data-collection-type].selected').data('collection-type'),
        option1name = $(this).data('option1name'),
        option1 = $(this).data('option1'),
        option2name = $(this).data('option2name'),
        option2 = $(this).data('option2')
        link = [];
  
  	if(type){
    	link.push(type)
    }
    $('[data-selected-meterial]').attr('class', '')
  	if(option1){
    	link.push(handle(option1name + '_' + option1));
      $('[data-selected-meterial]').addClass('filter-swatch-' + handle(option1))
    }
  	if(option2){
    	link.push(handle(option2name + '_' + option2));
      $('[data-selected-meterial]').addClass('filter-swatch-' + handle(option1) + '-' + handle(option2))
    }
  
  	link = link.join('+');
  
  
  	$('.vt-filter-link-container').removeClass('selected');
  	$(this).addClass('selected');

  
  

    if(!isProduct){
      filterPage({
        link : COLLECTION_URL + '/' + link
      });              	
    }else{
      
      	var _variants = $('[data-variants]').data('variants'),
            variants = JSON.parse($('[data-variants-json]').html()),
            selectedVariant = variants.find(function(variant){
            	
              return option2 ? (variant.option1 === option1 && variant.option2 === option2) :  variant.option1 === option1;
            });


        if(selectedVariant){
          filterPage({
            link : PRODUCT_URL + '?variant=' + selectedVariant.id
          });
        }else{
          filterPage({
            link : COLLECTION_URL + '/' + link
          })
        }
    }
  
    closeMobileFilters()
  
}).on('click', '.dropdown-toggle', function(){
	$(this).next().toggle()
}).on('click', function(e){
  if(!$(e.target).is('.dropdown') && !$(e.target).closest('.dropdown').length){
  	$('.currency-options-dropdown').hide()
  }

  if(!$(e.target).is('.vt-collection-filters-btn') && !$(e.target).closest('.vt-collection-filters-btn').length && !$(e.target).is('.vt-collection-filters') && !$(e.target).closest('.vt-collection-filters').length){
  	closeMobileFilters()
  }


  if(!$(e.target).is('.vt-swatches-filters-open') && !$(e.target).closest('.vt-swatches-filters-open').length && !$(e.target).closest('.vt-swatches-filters-groups').length){
	  $('.vt-swatches-filters').removeClass('open')
	}
  
}).on('click', '.vt-produc-accordian-header', function(e){
  $(this).find('svg path').last().fadeToggle(300)
  $(this).next().slideToggle()
}).on('change', '[data-filter-param]', function(e){

  var url = COLLECTION_URL;
  var filters = [];
  $('[data-filter-param]:checked').each(function(){
    filters.push($(this).data('filter-param') + '=' + $(this).val())
  })
  if(filters.length){
    url += ('?' + filters.join('&'));
  }

  window.location.href = url;
}).on('click', '[data-fabric-filters] .vt-filters-group', function(){
  var fabric = $(this).data('group');
  $(this).addClass('active').siblings().removeClass('active')
  $('[data-color-filters]').find('[data-color-group="'+fabric+'"]').addClass('active').siblings().removeClass('active')
}).on('click', '[data-filters-btn]', function(){
  $('[data-size-btn], .vt-collection-types-wrapper').removeClass('open')
  $(this).toggleClass('open').siblings('.vt-collection-filters').toggleClass('open')
}).on('click', '[data-size-btn]', function(){
  $('[data-filters-btn], .vt-collection-filters').removeClass('open')
  $(this).toggleClass('open').siblings('.vt-collection-types-wrapper').toggleClass('open')
}).on('change', '#cart_has_shipping_insurance', function(){
  var isChecked = $(this)[0].checked;
  if(isChecked){
    updateShippingInsurance(true)
  }else{
    removeShippingInsurance()
  }
}).on('click', '.cart-shipping-insurance a', function(e){

  e.preventDefault()

  $.get($(this).attr('href'), function(res){
    
      openModal({          
        name : 'shipping-insurance',
        header : 'Don\'t plan your day around a delivery.',
        body : res
      });

  })


}).on('click', '[data-checkout-protection]', function(e){

  e.preventDefault()
  var $this = $(this);
  var addProtection = JSON.parse($this.data('checkout-protection'));

  $this.loading();

  if(addProtection){
    updateShippingInsuranceBeforeCheckout().then(function(){
      $this.closest('form').submit()
    })
  }else{
    removeShippingInsuranceBeforeCheckout().then(function(){
      $this.closest('form').submit()
    })
      
  }

})



$(window).on("popstate", function(e) {  
  	if(e.originalEvent.state && e.originalEvent.state.url){
    	var prevUrl = e.originalEvent.state.url;    
      	filterPage({
          link : prevUrl,
          prev : true
      	})
    }else{
    	//window.location.reload();
    }
}).on('resize', function(){

	initHeader()
}).scroll(function(event){
  
  	
  	toggleSickyElements()
	
}).load(function(){
	initHeader();
});

function initHeader(){
  document.body.style.setProperty('--header-height', $('#vt-header-wrapper').outerHeight() +'px');
  $('.vt-collection-top-bar').css('top', $('#vt-header-wrapper').outerHeight())
  return;
	var headerHeight = $('#vt-header-wrapper').outerHeight(),
      isProductPage = window.location.pathname.indexOf('product') > -1,
      secondaryHeader = $('.panels-top-nav:visible, .vt-collection-top-bar:visible'),
      secondaryHeaderHeight = isProductPage ? 0 : secondaryHeader.outerHeight();
  
    secondaryHeaderHeight = secondaryHeader.outerHeight() || 0;
    
    $('#vt-header-wrapper').css('position', 'fixed')    
    secondaryHeader.css('top', headerHeight);//.css('position', 'fixed')
    //$('body').css('padding-top', headerHeight + secondaryHeaderHeight).data('top', headerHeight + secondaryHeaderHeight)
    $('body').css('padding-top', headerHeight).data('top', headerHeight)
}

function openMobileFilters(options){
	$('.vt-collection-filters').addClass('open');
  	$('body').addClass('freez');
}

function closeMobileFilters(){
	$('.vt-collection-filters, [data-filters-btn], [data-size-btn], .vt-collection-types-wrapper').removeClass('open');
  $('body').removeClass('freez');
  $('[data-selected-type]').text($('[data-collection-type].selected').text())
}

function initFancyBox(){
  if($('[data-fancybox="vt-fancybox"]').length){
  	$('[data-fancybox="vt-fancybox"]').fancybox({
        thumbs : {
            autoStart : true,
          	axis      : 'x'
        },
      	hash : false,
        buttons : [
            'thumbs',
            'zoom',
            'close'
        ],
    });
  }
}

function toggleSickyElements(manual){
	var st = window.pageYOffset || document.documentElement.scrollTop,
        filters = $('.vt-collection-filters'),
        down = st > lastScrollTop || (manual && $('.scrolled-down').length);
 
  	if (down){
      	//$('#vt-header-wrapper').addClass('scrolled-down')
      	$('.vt-swatches-filters').addClass('scrolled-down').removeClass('scrolled-up');
      	
        if(!MOBILE){
          	//$('.vt-collection-filters-inner').addClass('scrolled-down').removeClass('scrolled-up');
          	//freezFilters($('#vt-header-wrapper').height() + $('.vt-collection-top-bar').height())
        }
    }else{
      	$('#vt-header-wrapper').removeClass('scrolled-down')
      	$('.vt-swatches-filters').removeClass('scrolled-down').addClass('scrolled-up');
      	
      	if(!MOBILE){
        	//$('.vt-collection-filters-inner').removeClass('scrolled-down').addClass('scrolled-up');
      		//freezFilters($('#vt-header-wrapper').height() + $('.vt-collection-top-bar').height())
        }
    }
  
  	lastScrollTop = st <= 0 ? 0 : st;
  
  	function freezFilters(headerHeight){

      if(filters.length){
          	
          	var positionFromTop = $('body').data('top'),
            	filtersTop = filters.position().top,
                filtersHeight = $('.vt-collection-filters-inner').height(),
                productsHeight = $('.vt-collection-products-inner').height(),
                filtersBiggerFromProducts = filtersHeight > productsHeight || (filtersHeight > $(window).height() - positionFromTop),
                stickBottom = (st + filtersHeight) >= (filtersTop + filters.height()),
                stickTop = st >= filtersTop;
                
        
        	if(filtersBiggerFromProducts){
            	$('.vt-collection-filters-inner').css({
                  position:'static'
                })
          }else{          
                    
                if(stickTop && !stickBottom){
                    //console.log('top')
                    //$('.vt-collection-container').addClass('stick-top').removeClass('stick-bottom');  
                    $('.vt-collection-filters-inner').css({
                      position:'fixed',
                      top:positionFromTop,
                      bottom:'auto'
                    })
                }else if(stickBottom && stickTop){
                  //console.log('bottom')
                    //$('.vt-collection-container').addClass('stick-bottom').removeClass('stick-top');
                    $('.vt-collection-filters-inner').css({
                      position:'absolute',
                      top:'auto',
                      bottom:0
                    })
                }else{
                   // console.log('none')
    //                 $('.vt-collection-container').removeClass('stick-top');
    //               	$('.vt-collection-container').removeClass('stick-bottom');
                    $('.vt-collection-filters-inner').css({
                      position:'static'
                    })
                }    
              
            }
          	
        }
    }
}


function openCart(){
  	$('.vt-cart-container').scrollTop(0).loading();
	  $('.vt-cart-drawer').addClass('open');
  	$('body').addClass('freez');
  	loadCart()
}

function closeCart(){
	$('.vt-cart-drawer').removeClass('open');
  	$('body').removeClass('freez');
}

function updateHeaderCart(){
  $.get('/cart.json').then(function(cart){
  	$('[data-cart-count]').text(cart.item_count)
    if(cart.item_count > 0){
    	$('#CartCount').removeClass('d-none')
    }else{
    	$('#CartCount').addClass('d-none')
    }
  })
}

function loadCart(){

    $('#shopify-section-cart-template').find('[data-shipping-insurance-variant]').remove()
    
  	$('.vt-cart-container').load('/cart .cart', function(cart){
      if($('[data-cart-count]').text() == '0'){
        localStorage.vant_shipping_protection_added = false;
        removeShippingInsurance()
      }
    	updateTotals();  
      
      //updateShippingInsurance()
        
      
      // Extend — refresh cart offers on loadCart
      window.setTimeout(function() {
          window.dispatchEvent(new CustomEvent("refreshAjaxCart"))
      }, 500)
      // Extend - end Extend code
        
    });
  	updateHeaderCart();
}

function updateShippingInsurance(force){
  var $shippingInsuranceItem = $('.vt-cart-container [data-shipping-insurance-item]');
  var $shippingInsuranceVariant = $('.vt-cart-container [data-shipping-insurance-variant]');
  var shippingInsuranceItemId = $shippingInsuranceItem.data('shipping-insurance-item');
  var shippingInsuranceVariantId = $shippingInsuranceVariant.data('shipping-insurance-variant');

  if(shippingInsuranceItemId){

    

    if(shippingInsuranceItemId !== shippingInsuranceVariantId){
      
      // Remove
      jQuery.post('/cart/change.js', {
          quantity: 0,
          id: shippingInsuranceItemId
      }, function(cart){

          // Add
          jQuery.post('/cart/add.js', {
              quantity: 1,
              id: shippingInsuranceVariantId
          }, function(cart){

            loadCart()
          }, "json");
        
      }, "json");
    }


  }else{
      if(shippingInsuranceVariantId && (localStorage.vant_shipping_protection_added != "true" || force)){

        // Add
        jQuery.post('/cart/add.js', {
            quantity: 1,
            id: shippingInsuranceVariantId
        }, function(cart){

          localStorage.vant_shipping_protection_added = true;
          loadCart()
          
        }, "json");

    }
  }
}

function updateShippingInsuranceBeforeCheckout(){
  var $shippingInsuranceItem = $('.vt-cart-container [data-shipping-insurance-item]');
  var $shippingInsuranceVariant = $('.vt-cart-container [data-shipping-insurance-variant]');
  var shippingInsuranceItemId = $shippingInsuranceItem.data('shipping-insurance-item');
  var shippingInsuranceVariantId = $shippingInsuranceVariant.data('shipping-insurance-variant');

  return new Promise(function(resolve, reject) {
    if(shippingInsuranceItemId){

      if(shippingInsuranceItemId !== shippingInsuranceVariantId){
        
        // Remove
        jQuery.post('/cart/change.js', {
            quantity: 0,
            id: shippingInsuranceItemId
        }, function(cart){

            // Add
            jQuery.post('/cart/add.js', {
                quantity: 1,
                id: shippingInsuranceVariantId
            }, function(cart){

              resolve();
            }, "json");
          
        }, "json");
      }else{
        resolve();
      }


    }else{
        if(shippingInsuranceVariantId){

          // Add
          jQuery.post('/cart/add.js', {
              quantity: 1,
              id: shippingInsuranceVariantId
          }, function(cart){

            resolve();
            
          }, "json");

      }else{
        resolve();
      }
    }

  });
}

function removeShippingInsurance(){
  var $shippingInsuranceItem = $('.vt-cart-container [data-shipping-insurance-item]');
  var shippingInsuranceItemId = $shippingInsuranceItem.data('shipping-insurance-item');
  
  if(shippingInsuranceItemId){
  
        // Remove
        jQuery.post('/cart/change.js', {
            quantity: 0,
            id: shippingInsuranceItemId
        }, function(cart){
          loadCart()
          
        }, "json");
    }

}

function removeShippingInsuranceBeforeCheckout(){
  var $shippingInsuranceItem = $('.vt-cart-container [data-shipping-insurance-item]');
  var shippingInsuranceItemId = $shippingInsuranceItem.data('shipping-insurance-item');

  return new Promise(function(resolve, reject) {
    if(shippingInsuranceItemId){
  
      // Remove
      jQuery.post('/cart/change.js', {
          quantity: 0,
          id: shippingInsuranceItemId
      }, function(cart){
        resolve();
      }, "json");
    }else{
      resolve();
    }
  });
  
  

}


function updateTotals(){

    if(window.affirm){
    	affirm.ui.refresh();
    }

    return;
  
	var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", '/checkout', false); // false for synchronous request
      xmlHttp.send(null);
      var checkoutHtml = $(xmlHttp.responseText);

  	if(checkoutHtml.find('[data-checkout-subtotal-price-target]').length){
  		$('[data-cart-total]').addClass('d-flex').find('.cart-total-price').html(checkoutHtml.find('[data-checkout-subtotal-price-target]').html());
    }
  
  	var subTotalElm = checkoutHtml.find('[data-checkout-payment-due-target]');
  
  
  	if(checkoutHtml.find('[data-checkout-discount-amount-target]').length){
      	
        var discountCode = checkoutHtml.find('.reduction-code__text').html();
        		            
        $('[data-cart-discount]').find('.cart-discount-code').html(discountCode);
        $('[data-cart-discount]').addClass('d-flex').find('.cart-discount-price').html(checkoutHtml.find('[data-checkout-discount-amount-target]').html());
      	$('.additional-checkout-buttons').hide();
      	
    }    

      
  	$('[data-cart-subtotal]').addClass('d-flex').find('.cart-subtotal-price').html(subTotalElm.html());
  	$('.cart .affirm-as-low-as').attr('data-amount', Number(subTotalElm.data('checkout-payment-due-target')) * 100)
    if(window.affirm){
    	  affirm.ui.refresh();
    }
}

function initFilters(){

   
    if(!$('.vt-collection-filters:visible').length){
      return _initFilters();
    }
  
	
  	if($('.vt-collection-filters:visible .vt-filters-group-color').length){
      return;
    }

  
	
  	var $options = $('[data-options]'),
        $filters = $('[data-filter-groups]'),
        $fabricFilters = $('[data-fabric-filters-items]'),
        $colorFilters = $('[data-color-filters]'),
        filters = {},
        pathname = location.pathname;
  
  	$options.each(function(options){
      
      	var options = $(this).find('[data-options-json]').html() ? JSON.parse($(this).find('[data-options-json]').html()) : [],
            optionNames = $(this).find('[data-option-names-json]').html() ? JSON.parse($(this).find('[data-option-names-json]').html()) : [];
      	
      if(optionNames && optionNames.length){
            options.forEach(function(option, index){
                
              	if(optionNames.length > 1){

                    var option1 = option[0],
                        option1handle = handle(option1),
                        option2 = option[1],
                        option2handle = handle(option2),
                        filter_tag = handle(optionNames[1]) + '_' + option2handle,
                        product_tag = handle(optionNames[1]) + '_' + handle($options.data('option2')),
                        isSelected = pathname.indexOf(filter_tag) > -1 || filter_tag === product_tag;
                  		
                    if(!filters[option1]){
                        filters[option1] = [];
                        var isActive = pathname.indexOf(option1handle) > -1;
                        $fabricFilters.append('<div class="vt-filters-group '+(isActive ? 'active' : '')+'" data-group="'+option1handle+'" data-filter-key="'+handle(optionNames[0])+'">'+option1+'</div>')
                        $colorFilters.append('<div data-color-group="'+option1handle+'" class="vt-filters-group vt-filters-group-color '+(isActive ? 'active' : '')+'"><div class="vt-filter-body"></div></div>')
                    }

                    if(filters[option1].indexOf(option2) === -1){
                        filters[option1].push(option2);
                        //$('[data-group="'+option1handle+'"] .vt-filter-body').append('<label class="vt-filter-link-container '+(isSelected ? 'selected' : '')+'" data-option1name="'+optionNames[0]+'" data-option2name="'+optionNames[1]+'" data-option1="'+option1+'" data-option2="'+option2+'"><span class="vt-filter-link" ><span class="vt-filter-swatch bg-center filter-swatch-'+option2handle+' filter-swatch-'+option1handle+'-'+option2handle+'" data-filter-swatch="'+option2handle+'"></span><span class="vt-filter-value">'+option2+'</span></span></label>');
                        $('[data-color-group="'+option1handle+'"] .vt-filter-body').append('<label class="vt-filter-link-container '+(isSelected ? 'selected' : '')+'" data-option1name="'+optionNames[0]+'" data-option2name="'+optionNames[1]+'" data-option1="'+option1+'" data-option2="'+option2+'"><span class="vt-filter-link" ><span class="vt-filter-swatch bg-center filter-swatch-'+option2handle+' filter-swatch-'+option1handle+'-'+option2handle+'" data-filter-swatch="'+option2handle+'"></span><span class="vt-filter-value">'+option2+'</span></span></label>');
                    }
                  
                }else{
          
                    var option1 = optionNames[0],
                        option1handle = handle(option1),
                        option2 = option[0],
                        option2handle = handle(option2),
                        filter_tag = option1handle + '_' + option2handle,
                        product_tag = handle(optionNames[1]) + '_' + handle($options.data('option1')),
                        isSelected = pathname.indexOf(filter_tag) > -1 || filter_tag === product_tag;
                  
                  	if(!filters[option1]){
						          filters[option1] = [];
                    	$filters.append('<div class="vt-filters-group vt-filters-group-color initalized" data-group="'+option1handle+'" data-filter-key="'+handle(optionNames[0])+'"><div class="vt-filter-header grouped">'+option1+'</div><div class="vt-filter-body d-flex flex-wrap"></div></div>')        	
                    }
                  	filters[option1].push(option2);
                  	$('[data-group="'+option1handle+'"] .vt-filter-body').append('<label class="vt-filter-link-container '+(isSelected ? 'selected' : '')+'" data-option1name="'+optionNames[0]+'" data-option1="'+option2+'"><span class="vt-filter-link" ><span class="vt-filter-swatch bg-center filter-swatch-'+option2handle+'" data-filter-swatch="'+option2handle+'"></span><span class="vt-filter-value">'+option2+'</span></span></label>');
                  
                }
            });

           
    	}
        
      
    });

    if(!$fabricFilters.find('.active').length){
      $fabricFilters.find('.vt-filters-group').first().addClass('active');
    }

    if(!$colorFilters.find('.active').length){
      $colorFilters.find('.vt-filters-group').first().addClass('active').find('.vt-filter-link-container').first().addClass('selected');
    }

    var selectedFabric = $fabricFilters.find('.vt-filters-group.active').data('group');
    var selectedColor = $colorFilters.find('.vt-filters-group.active').find('.vt-filter-link-container.selected').find('.vt-filter-swatch').data('filter-swatch');

    $('[data-selected-meterial]').addClass('filter-swatch-' + selectedColor);
    $('[data-selected-meterial]').addClass('filter-swatch-' + selectedFabric + '-' + selectedColor);

    $('[data-selected-type]').text($('[data-collection-type].selected').text())
  
}

function handle(val){
  return val ? val.toLowerCase().replace(/ /g,'-') : val;
}

function _initFilters(refresh, e){

	var variantOptions,
    	link = '',
        variantOptionsString = '',
        isSingleFilter = $('.vt-swatches, .vt-inspirations').length;
    
  
  	//Eanable disable filters
    $('[data-filter-group]:first').addClass('initalized')
    $('[data-filter-group]:first [data-value]').addClass('available')
  	$('[data-filter-group]:not(:first)').each(function(){
        
      	var otherSelectedFilterGroups = $('[data-filter-group]').not(this),
            otherFilters = [];
      
      	otherSelectedFilterGroups.each(function(){
        		
          	otherFilters.push($(this).find('input:checked').closest('[data-value]').data('value'))
          
        });
     
        if(!$('.vt-product-simple').length){

      
        	$(this).find('[data-value]').each(function(){
          
            	var filter = $(this).data('value'),
                	filters = _.clone(otherFilters);
              
              	filters.push(filter)
                  filters = filters.sort();
              	var filtersString = filters.join();
                        	
              	var filterIsAvailable = optionAvailable(filtersString, filters);
                        
              	if(!filterIsAvailable){
                	$(this).removeClass('available').addClass('unavailable');
                }else{
                	$(this).addClass('available').removeClass('unavailable');
                }          
              
            
            });
        }else{
          $(this).find('[data-value]').each(function(){
          
            	var filter = $(this).data('value'),
                	filters = _.clone(otherFilters);
              
              	filters.push(filter)
                  filters = filters.sort();
              	var filtersString = filters.join();

              	var filterIsAvailable = optionAvailable(filtersString, filters);
                        
              	if(!filterIsAvailable){                  
                	$(this).addClass('inactive');//.attr('checked', false);
                }else{
                	$(this).removeClass('inactive').find('.vt-filter-swatch').addClass('filter-swatch-' + filtersString.split(',').join('-'));
                }          
              
            
            });
        }
      
      	$(this).addClass('initalized')
        

    });
  
  	if($('.vt-product-simple').length){
          $('[data-filter-group] [data-value]').each(function(){
          
          	var filterIsChecked = $(this).find('input:checked').length;
                 
              if(!filterIsChecked){
                  $(this).find('.vt-collection-type').removeClass('selected');
              }else{
                  $(this).find('.vt-collection-type').addClass('selected');
              }          
            
          
          });
    }
  	setSelectedFilters(refresh)        
    
    
    // $('[data-collection-type]:not(.product-type-selected)').each(function(){
    
    // 	var url = window.location.href,
    //     	type = $(this).data('collection-type');
      
      
    //     if(url.indexOf(type) > -1){
    //         $(this).addClass('selected')
    //     }else{
    //         $(this).removeClass('selected')
    //     }
      
    // });
  
  	if(!$('[data-collection-type].selected').length){
      $('[data-collection-type]:first').addClass('selected').click();
    }
    	
  	if($('.vt-product-description-inner').length){
      	var selectedSwatch = $('.vt-product-simple').find('input:checked').toArray().map(function(input){
          return input.value.split('_')[1];
        }).join('_')
        
        if(variantBuletPoints[selectedSwatch]){
          
          	_.each(variantBuletPoints[selectedSwatch], function(point){              
              $('.vt-product-description ul:last').append('<li aaa>'+point+'</li>')
            })
            _.each(variantBuletPoints['panel_' + selectedSwatch], function(point){              
              $('.vt-product-description ul:last').append('<li bbb>'+point+'</li>')
            })
        }
      
      
    } 
  
  	initHeader();
  
    
    function setSelectedFilters(refresh){
      	variantOptions = [];
    	link = $('[data-collection-type].selected').length ? [$('[data-collection-type].selected').data('collection-type')] : [];
      	      
      	$('[data-filter-group]').each(function(){
    	
          if($(this).find('[data-value].available').length){
              var option = (refresh && isSingleFilter) ? $(this).find('[data-value].available').find('input:checked').val() : $(this).find('[data-value].available').find('input:checked').val() || $(this).find('[data-value].available:first').find('input').prop('checked', true).val() || $(this).find('[data-value].available').find('input:checked').val() || $(this).find('[data-value].available:first').find('input').prop('checked', true).val(),
                  optionValue = option ? option.split('_')[1] : '';

              
              link.push(option);
              variantOptions.push(optionValue);
          }

        });
		    link = link.join('+');
        variantOptions = variantOptions.sort();
        variantOptionsString = variantOptions.join();

      
      if(refresh){ 
        
        	var PRODUCT_URL = window.location.pathname,
            	isProduct = PRODUCT_URL.indexOf('product');
        
            if(!isProduct){
              	filterPage({
                  link : COLLECTION_URL + '/' + link
                })              	
            }else{
              	var filters = [],
                    filter_options = [];
              
              	$('[data-filter-group]').each(function(){                           
                    filters.push($(this).find('input:checked').closest('[data-value]').data('value'));
                    filter_options.push($(this).find('input:checked').next().find('.vt-filter-value').text() || $(this).find('input:checked').next().text().trim())
                });

                
              	filters = filters.sort();

                var filtersString = filters.join();
              	var variant = getVariant(filtersString, filter_options)
              
                if(variant){
                  	filterPage({
                      link : PRODUCT_URL + '?variant=' + variant.id
                    });
                }else{
                    console.log('not available')
                   $('[data-atc]').attr('disabled', 'disabled').text('Unavailable')
                  	// filterPage({
                   //    link : COLLECTION_URL + '/' + link
                   //  })
                }
            }
        	
      }
      	
      // Extend - trigger refresh product offer event after product variant change
      window.dispatchEvent(new CustomEvent("refreshProductOffer"))
      // Extend - end Extend code
    }
  
  	function getVariant(filtersString, filter_options){
      	var variant;

    	$('[data-variants-json]').each(function(){
            	
          var _variants = $(this).data('variants');
          var variants = JSON.parse($(this).html());
          var findVariant =  _.find(variants, function(v){
            var option = v.options.join('|').toLowerCase().replace(/ - /g, '-').replace(/ /g, '-').replace('\'', '').replace('\'', '').replace('"', '').replace('"', '').replace('-+-', '-').replace('-&-', '-').replace('-/-', '-').replace(/\//g, '-').split('|').sort().join();
            return option === filtersString;

          });

       
          if(findVariant){
          	variant = findVariant;
          }else if($('.vt-product-simple').length){

            var filterGroupIndex = $(e.target).closest('.vt-collection-types').index();
            findVariant = _.find(variants, function(v){
                
              if(filter_options[2]){

                console.log(filterGroupIndex)
                console.log(filter_options)
                
                //return v.option1 === filter_options[0] && v.option2 === filter_options[1] && v.option2 === filter_options[2];
                return v.option1 === filter_options[0] && (filterGroupIndex === 1 ? v.option2 === filter_options[1] : v.option3 === filter_options[2]);
                
              }else if(filter_options[1]){
                
                return filterGroupIndex === 0 ? v.option1 === filter_options[0] : v.option2 === filter_options[1];
                
              }
  
            });
            if(findVariant){
            	variant = findVariant;
            }
          }

        });
      	return variant;
    }	
  
  	function optionAvailable(filtersString, filters){
      	var variant;

    	$('[data-options]').each(function(){
            	 
          var options = $(this).find('[data-options-json]').length ? JSON.parse($(this).find('[data-options-json]').html()) : [];
          
          // var findVariant =  _.find(options, function(opt){
          //   var option = opt.join('|').toLowerCase().replace(/ - /g, '-').replace(/ /g, '-').replace('\'', '').replace('\'', '').replace('"', '').replace('"', '').replace('-+-', '-').replace('-&-', '-').replace('-/-', '-').replace(/\//g, '-').split('|').sort().join();
          //   return option === filtersString;
            
          // });

          // if(findVariant){
          // 	variant = findVariant;
          // }


          const match = options.find(arr =>
            filters.every(val => {
              return arr.map(handlelize).includes(handlelize(val))
            })
          );

          if(match){
            variant = match;
          }
          
          

        });
        
      	return variant;
    }	
  
}

function filterPage(settings){
 
    	
  	var link = settings.link,
        prev = settings.prev,
        currentPath = window.location.pathname,
        fullReload = settings.fullReload,
        loadingProduct = settings.link.indexOf('products') > -1,
        loadingSwatchesOrInsperation = $('.vt-swatches-filters-bar, .vt-inspirations').length;
    
  
  	if(!prev){
    	window.history.pushState({
          url : link
        }, null, link);
    }
  	
   	$('.vt-collection-products').loading();
  
  	$(document).trigger('APPLYING_FILTERS');
  
  	if(loadingSwatchesOrInsperation){
    
      	$('.vt-xhr-container').load(link + ' .vt-xhr-inner', function(){    	       	
                
          $(document).trigger('FILTERS_APPLIED')

        });
      
    }else{
  
        if(loadingProduct){
          
			
          	$.get(link + '&section_id=' + PRODUCT_SECTION_ID, function(res){
              var xhrContent = $(res).find('.vt-xhr-container').html()
            	 $('#shopify-section-' + PRODUCT_SECTION_ID).replaceWith(res)            		   	       	
                  //$('.vt-collection-container').addClass('vt-product-detail-container');
              
              	  //$('[data-recommended-links-container]').html($('[data-recommended-links]').html())
              
                  initFilters()              

                  if(window.SPR){
                      SPR.initDomEls();
                      SPR.loadBadges();
                  }
                  //SPR.loadProducts();

                  initProductSliders()

                  $(document).trigger('FILTERS_APPLIED')
                  toggleSickyElements(true);
                  initFancyBox();

                  if(window.affirm){
                    affirm.ui.refresh();
                  }

          }) 

        }else if(fullReload){

          $('.vt-collection-container').load(link + ' .vt-collection-container-reload', function(){    	       	

              //$('.vt-collection-container').removeClass('vt-product-detail-container')
            
              initHeader();
              initFilters()
              $(document).trigger('FILTERS_APPLIED')
              toggleSickyElements(true);
              closeMobileFilters()

          }) 
                    
          	//window.location.href = link;

        }else{

            $('.vt-collection-products').load(link + '?view=xhr', function(){    	       	
                //initFilters()
                //$('.vt-collection-container').removeClass('vt-product-detail-container')
                $(document).trigger('FILTERS_APPLIED')
                toggleSickyElements(true);
                var collection_link = link.split('/');
                collection_link.pop();
                COLLECTION_URL = collection_link.join('/');

                closeMobileFilters()

            })    
        }
     
      
      $('html, body').animate({
        scrollTop: 0
      })
    }
  
}

function initProductSliders(){
  
    // if($('.vt-product-slider').length){

    //   	var sliderContainerWidth = $('.vt-product-slider').outerWidth(true),
    //         totlSlidesWidth = $('.vt-product-slide').length * $('.vt-product-slide').outerWidth(true);
    //     if(totlSlidesWidth > sliderContainerWidth || (MOBILE && $('.vt-product-slide').length > 1)){
    //       $('.vt-product-slider').removeClass('d-flex').addClass('mb-5').flickity({
    //             adaptiveHeight: true,
    //             wrapAround: true,
    //             freeScroll: true,
    //             contain: true,
    //               cellAlign: 'left'
    //       });
    //     }
    // }

    if(document.querySelectorAll('[data-product-nav-gallery] .swiper-slide').length < 2){
      return;
    }

    var productGalleryNav = new Swiper('[data-product-nav-gallery]', {
        // Optional parameters
        slidesPerView : 'auto',
        loop:true,
        freeMode: true,
        watchSlidesProgress: true,
    });

    var productGallery = new Swiper('[data-product-gallery]', {
        // Optional parameters
        slidesPerView : 'auto',
        //loop:true,

        //   // Navigation arrows
        navigation: {
            nextEl: '[data-product-gallery] .swiper-button-next',
            prevEl: '[data-product-gallery] .swiper-button-prev',
        },
        pagination: {
          el: '.vt-product-detail .swiper-pagination',
          clickable: true
        },
        thumbs: {
          swiper: productGalleryNav,
        },
    });

    

    

    // productGallery.controller.control = productGalleryNav;
    // productGalleryNav.controller.control = productGallery;
}

function openModal(settings){
	  
  	MODAL_PROMISE = new Promise(function(resolve, reject) {
      
      $('.vt-modal-header h2').html(settings.header);
  		$('.vt-modal-body').html(settings.body)
  		$('.vt-modal').addClass('in').attr('modal', settings.name);
      
      resolve();
  	});  
  
  	return MODAL_PROMISE;
  
}

function closeModal(){
	
  	$('.vt-modal').removeClass('in');
  	setTimeout(function(){
  		$('.vt-modal-header h2').html('');
  		$('.vt-modal-body').html('')
  	}, 600)  	
  
}

function initCountDown(){
	var elm = $('[data-countdown]'),
        endDate = elm.data('countdown');
  	
  	if(endDate){
      	var countdown = setInterval(function() {
            var now = Date.now(),
                endTime = new Date(endDate).setHours(23,59,59,999),
                distance = endTime - now,
                days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((distance % (1000 * 60)) / 1000),
                daysLabel = days === 1 ? 'Day ' : 'Days ',
                daysSpan = '<strong>' + (days < 10 ? '0'+Math.max(days, 0) : days) + '</strong>' + daysLabel,
                hoursLabel = hours === 1 ? 'Hrs ' : 'Hrs ',
                hoursSpan = '<strong>' + (hours < 10 ? '0'+Math.max(hours, 0) : hours) + '</strong>' + hoursLabel,
                minutesLabel = minutes === 1 ? 'Min ' : 'Min ',
                minutesSpan = '<strong>' + (minutes < 10 ? '0'+Math.max(minutes, 0) : minutes) + '</strong>' + minutesLabel,
                secondsLabel = seconds === 1 ? 'Sec ' : 'Sec ',
                secondsSpan = '<strong>' + (seconds < 10 ? '0'+Math.max(seconds, 0) : seconds) + '</strong>' + secondsLabel;
          
			
            elm.html(daysSpan + hoursSpan + minutesSpan + secondsSpan)
            
            if (distance < 0) {
              clearInterval(countdown);
            }
        }, 1000);
    }
}
